import { useContext } from 'react';
import { OriginActionContext } from '../contexts/OriginActionContext';

const useOriginAction = () => useContext(OriginActionContext);

export default useOriginAction;
